import styled from "@emotion/styled";
import theme from "@theme";

const BodyHeader = styled.div`
  padding: 16px 24px;
  background: linear-gradient(135deg, #e36e00 0%, #ffae00 100%);
  backdrop-filter: blur(10px);
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  position: fixed;
  width: 100%;
  z-index: 1000;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
`;

const BodyContainer = styled.div`
  margin-top: 50px;
`;

const HeadingTag = styled.p`
  float: left;
  margin: 5px;
  padding: 0px 20px 0px 0px;
  font-weight: bold;
`;

const FilterContainer = styled.div`
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(10px);
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  padding: 16px 24px;
  display: flex;
  gap: 16px;
  justify-content: flex-end;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);

  @media (max-width: 768px) {
    justify-content: flex-start;
    flex-wrap: wrap;
  }
`;

const FilterOption = styled.p`
  padding: 5px 0px -20px 10px;
`;

const Container = styled.div``;

const ActiveContainer = styled.div`
  padding: 20px;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
`;

const ImageContainer = styled.div`
  width: 150px;
  height: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  border: 1px solid ${theme.colors.bordertask};
`;

const Image = styled.div`
  width: 130px;
  height: 80px;
  border: 2px solid ${theme.colors.greyColor};
  border-radius: 8px;
  overflow: hidden;
`;

const ProjectDiv = styled.div`
  margin-left: 50px;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;
const PropertyName = styled.span`
  font-weight: bold;
  font-size: 20px;
  // text-transform: uppercase;
`;

const Status = styled.div`
  color: ${(props) => (props.currentProject.status === 1 ? " #2FAC39" : "red")};
  font-weight: bold;
  font-size: 16px;
  margin: 5px 0px;
`;
const Email = styled.span`
  font-size: 15px;
  color: #555;
`;

const ButtonContaiiner = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  padding: 10px;
  margin-left: 15px;
  border-top: 1px solid ${theme.colors.bordertask};

  // @media (max-width: 600px) {
  //   flex-direction: column;
  //   align-item: right;
  //   justify-content: start;
  // }
`;
const SC = {
  Container,
  BodyHeader,
  BodyContainer,
  HeadingTag,
  FilterContainer,
  FilterOption,
  ActiveContainer,
  ImageContainer,
  Image,
  ProjectDiv,
  PropertyName,
  Status,
  Email,
  ButtonContaiiner,
};

export default SC;
